/** Angular Imports */
import { Component, OnInit } from '@angular/core';

/**
 * External Services component.
 */
@Component({
  selector: 'mifosx-external-services',
  templateUrl: './external-services.component.html',
})
export class ExternalServicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
